import axios from "axios";

export default function updateProfile({ username }) {
  return new Promise((resolve, reject) => axios
    .put(`/account/system-admin/api/v1/profile`, {
      username
    })
    .then((response) => resolve(response.data))
    .catch((error) => reject(error.message))
  );
}
